export default {
  computed: {
    app () {
      return {
        company_name: 'Novict B.V.',
        name: this.getName(),
        name_short: this.getNameShort(),
        tag: 'v10.1.5',
        // changing this version will reset local storage (but keeps session)
        data_structure_version: 4,
        isBeta: this.isBetaVersion(),
        isBetaSwitchEnabled: this.isBetaSwitchEnabled()
      }
    }
  },
  methods: {
    isBetaVersion () {
      if (
          process.env.VUE_APP_BASE === '/groepsapp-beta/'
          || process.env.VUE_APP_BASE === '/gastouderapp-beta/'
      ) {
        return true
      } else {
        return false
      }
    },
    isBetaSwitchEnabled () {
      if (process.env.VUE_APP_BETA_SWITCH === 'true' && this.getApplicationSetting('ipad_beta_access') === '1') {
        return true
      } else {
        return false
      }
    },
    getName() {
      if (process.env.VUE_APP_BASE === '/gastouderapp/') {
        return 'Kidsadmin Gastouderapp';
      } else {
        return 'Kidsadmin Groepsapp'
      }
    },
    getNameShort() {
      if (process.env.VUE_APP_BASE === '/gastouderapp/') {
        return 'Gastouderapp'

      } else {
        return 'Groepsapp'
      }
    }
  }
}
